import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface EmailVerificationWrapperProps {
  children: React.ReactNode;
}

export const EmailVerificationWrapper = ({ children }: EmailVerificationWrapperProps) => {
  const { isEmailUnverified, isAwaitingApproval, loading, user, isInPasswordResetFlow } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Skip redirect if still loading, on auth pages, or in password reset flow
    if (loading || isInPasswordResetFlow) return;
    
    const authPages = ['/login', '/signup', '/auth/confirm', '/email-verification', '/awaiting-approval', '/reset-password', '/forgot-password', '/', '/about', '/contact', '/privacy', '/terms', '/refund-policy'];
    const isOnAuthPage = authPages.includes(location.pathname);

    // If user has unverified email and not on auth pages, redirect to verification
    if (isEmailUnverified && !isOnAuthPage) {
      navigate('/email-verification', { replace: true });
    }
    
    // If user is awaiting approval and not on auth pages, redirect to awaiting approval
    if (isAwaitingApproval && !isOnAuthPage) {
      navigate('/awaiting-approval', { replace: true });
    }
    
    // If user is verified and approved, and on verification/approval pages, redirect to dashboard
    if (user && user.isApproved && !isEmailUnverified && (location.pathname === '/email-verification' || location.pathname === '/awaiting-approval')) {
      navigate('/dashboard', { replace: true });
    }
  }, [isEmailUnverified, isAwaitingApproval, loading, user, navigate, location.pathname, isInPasswordResetFlow]);

  return <>{children}</>;
};